import { DashboardCountStatus } from '@/models';

export type MatchStatus = (s: DashboardCountStatus) => boolean;

export class StatusIconViewModel {
  constructor(
    public name: string,
    public match: MatchStatus,
    public iconHolderClass: string,
    public icon: string) {
  }
}
